var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H21C21.8284 3 22.5 3.67157 22.5 4.5V6H1.5V4.5C1.5 3.67157 2.17157 3 3 3ZM24 4.5C24 2.84315 22.6569 1.5 21 1.5H3C1.34315 1.5 0 2.84315 0 4.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V4.5ZM1.5 19.5V7.5H22.5V19.5C22.5 20.3284 21.8284 21 21 21H3C2.17157 21 1.5 20.3284 1.5 19.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78847 17.7738C4.57981 17.5526 4.48527 17.0677 4.69393 16.8464L7.31971 14.0783L4.73525 11.4005C4.52659 11.1792 4.33141 10.7984 4.73525 10.3702C5.08805 9.99601 5.55487 10.0952 5.76353 10.3165L8.81294 13.5312C9.0216 13.7525 9.07723 14.3119 8.86857 14.5332L5.63855 17.8769C5.42989 18.0981 4.99712 17.9951 4.78847 17.7738Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.25C12 16.8358 12.3358 16.5 12.75 16.5H18.75C19.1642 16.5 19.5 16.8358 19.5 17.25C19.5 17.6642 19.1642 18 18.75 18H12.75C12.3358 18 12 17.6642 12 17.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/command.826746e040547e1f9e76e660f4764fbb.svg";